import React from "react";
import { useHistory } from "react-router";
import { Button, Table, Form, DatePicker, Typography } from "antd";
import { useModelDispatchers } from "../../../models";


const columns = [
    {
        title: '日期',
        dataIndex: 'name',
        align: 'left',
    },
    {
        title: '摘要',
        dataIndex: 'date',
    },
    {
        title: "入库",
        children: [
            {
                title: '数量',
                key: 'inNum',
                dataIndex: 'inNum',
            },
            {
                title: '单价',
                key: 'inPrince',
                dataIndex: 'inPrince',
            },
            {
                title: '金额',
                key: 'inAmount',
                dataIndex: 'inAmount',
            },
        ]
    },
    {
        title: '出库',
        children: [
            {
                title: '数量',
                dataIndex: 'outNum',
            },
            {
                title: '单价',
                dataIndex: 'outPrice',
            },
            {
                title: '金额',
                dataIndex: 'outAmount',
            },
        ]
    },
    {
        title: '期末',
        children: [
            {
                title: '数量',
                dataIndex: 'endNum',
            },
            {
                title: '金额',
                dataIndex: 'endAmount',
            },
        ]
    },
    {
        title: '业务单号',
        dataIndex: 'status',
    },
    {
        title: '对方单位',
        dataIndex: 'status',
    },
];
const data = [
    {
        key: '1',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '2',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '3',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '4',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '5',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
    {
        key: '6',
        code: '001002003004',
        name: "北京八方达公交公司",
        date: '2020-09-09',
        unOutCount: 33,
        status: '已开单'
    },
];

const TableHeader = () => {
    const history = useHistory();
    const { setPssVisible, setMoveVisible } = useModelDispatchers("stockStatistic");


    const [form] = Form.useForm();

    const onFinish = () => {
    }


    const onValuesChange = e => {

    }

    return (
        <div style={{ margin: "0 0 8px", display: "flex" }}>
            <div style={{ flex: 1 }}></div>
            <div style={{ width: "500px" }}>
                <Form
                    form={form}
                    name="material_search"
                    layout="inline"
                    onFinish={onFinish}
                    onValuesChange={onValuesChange}
                >
                    <Form.Item name="startEndDate" label="日期" rules={[{ type: 'array', required: false, message: '请选择制单日期!' }]}>
                        <DatePicker.RangePicker />
                    </Form.Item>
                    <Form.Item shouldUpdate={true}>
                        {() => (
                            <>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    查询
                        </Button>
                                <Button
                                    htmlType="submit"
                                    className="margin-left-8"
                                >
                                    重置
                        </Button>
                            </>
                        )}
                    </Form.Item>
                </Form>
            </div>

        </div>
    )
}

const tableSummary = pageData => {
    let totalBorrow = 0;
    let totalRepayment = 0;

    pageData.forEach(({ borrow, repayment }) => {
        totalBorrow += borrow;
        totalRepayment += repayment;
    });
    return (
        <>
            <Table.Summary.Row>
                <Table.Summary.Cell>合计</Table.Summary.Cell>
                <Table.Summary.Cell></Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text type="danger">{totalBorrow}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text>{totalRepayment}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text type="danger">{totalBorrow}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text>{totalRepayment}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text type="danger">{totalBorrow}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text>{totalRepayment}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text type="danger">{totalBorrow}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                    <Typography.Text>{totalRepayment}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell></Table.Summary.Cell>
                <Table.Summary.Cell></Table.Summary.Cell>
            </Table.Summary.Row>
        </>
    )
}
export default function () {
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={data}
                bordered
                pagination={true}
               
                scroll={{ x: 'max-content' }}
                summary={tableSummary}
            />
        </>
    );
}